const mineList = [{
        path: "/myInfo",
        name: "myInfo",
        component: () =>
            import ("@/views/mine/myInfo.vue"),
        meta: {
            title: "我的资料",
            isLogin: true
        }
    },
    {
        path: "/xieyi",
        name: "xieyi",
        component: () =>
            import ("@/views/mine/xieyi.vue"),
        meta: {
            title: "隐私协议",
            isLogin: true
        }
    },
    {
        path: "/testPhone",
        name: "testPhone",
        component: () =>
            import ("@/views/mine/testPhone.vue"),
        meta: {
            title: "绑定手机",
            isLogin: true
        }
    },
    {
        path: "/bindPhone",
        name: "bindPhone",
        component: () =>
            import ("@/views/mine/bindPhone.vue"),
        meta: {
            title: "绑定手机",
            isLogin: true
        }
    },
    {
        path: "/scoreList",
        name: "scoreList",
        component: () =>
            import ("@/views/mine/scoreList.vue"),
        meta: {
            title: "积分明细",
            isLogin: true
        }
    },
    {
        path: "/myCollect",
        name: "myCollect",
        component: () =>
            import ("@/views/mine/myCollect.vue"),
        meta: {
            title: "我的收藏",
            isLogin: true
        }
    },
    {
        path: "/applyQuoted",
        name: "applyQuoted",
        component: () =>
            import ("@/views/mine/applyQuoted.vue"),
        meta: {
            title: "挂牌申请",
            isLogin: true
        }
    },
    {
        path: "/updateQuoted",
        name: "updateQuoted",
        component: () =>
            import ("@/views/mine/updateQuoted.vue"),
        meta: {
            title: "挂牌修改",
            isLogin: true
        }
    },
    {
        path: "/myHouseManage",
        name: "MyHouseManage",
        component: () =>
            import ("@/views/mine/myHouseManage.vue"),
        meta: {
            title: "我的房源管理",
            isLogin: true
        }
    },
    {
        path: "/addApply",
        name: "AddApply",
        component: () =>
            import ("@/views/mine/addApply.vue"),
        meta: {
            title: "申请新增",
            isLogin: true
        }
    },
    {
        path: "/updateApply",
        name: "UpdateApply",
        component: () =>
            import ("@/views/mine/updateApply.vue"),
        meta: {
            title: "申请修改",
            isLogin: true
        }
    },
    {
        path: "/systemMsg",
        name: "SystemMsg",
        component: () =>
            import ("@/views/mine/systemMsg.vue"),
        meta: {
            title: "系统消息",
            isLogin: true
        }
    },
    {
        path: "/myOrder",
        name: "MyOrder",
        component: () =>
            import ("@/views/mine/myOrder.vue"),
        meta: {
            title: "我的二手房预约",
            isLogin: true
        }
    },
    {
        path: "/websiteInfo",
        name: "WebsiteInfo",
        component: () =>
            import ("@/views/mine/websiteInfo.vue"),
        meta: {
            title: "网点信息",
            isLogin: true
        }
    },
    {
        path: "/underLineOrder",
        name: "UnderLineOrder",
        component: () =>
            import ("@/views/mine/UnderLineOrder.vue"),
        meta: {
            title: "线下业务预约",
            isLogin: true
        }
    },
    {
        path: "/orderDetail",
        name: "OrderDetail",
        component: () =>
            import ("@/views/mine/orderDetail.vue"),
        meta: {
            title: "预约详情",
            isLogin: true
        }
    },
    {
        path: "/escrowAgreement",
        name: "EscrowAgreement",
        component: () =>
            import ("@/views/mine/escrowAgreement.vue"),
        meta: {
            title: "二手房监管协议",
            isLogin: true
        }
    },
    {
        path: "/myHouseDeal",
        name: "MyHouseDeal",
        component: () =>
            import ("@/views/mine/myHouseDeal.vue"),
        meta: {
            title: "我的二手房交易",
            isLogin: true
        }
    },
    {
        path: "/jointOwner",
        name: "JointOwner",
        component: () =>
            import ("@/views/mine/jointOwner.vue"),
        meta: {
            title: "增加共有人",
            isLogin: true
        }
    },
    {
        path: "/myContract",
        name: "MyContract",
        component: () =>
            import ("@/views/mine/myContract.vue"),
        meta: {
            title: "我的商品房合同",
            isLogin: true
        }
    },
    {
        path: "/cloudSign",
        name: "CloudSign",
        component: () =>
            import ("@/views/mine/cloudSign.vue"),
        meta: {
            title: "商品房合同云网签",
            isLogin: true
        }
    },
    {
        path: "/updatePwd",
        name: "UpdatePwd",
        component: () =>
            import ("@/views/mine/updatePwd.vue"),
        meta: {
            title: "修改密码",
            isLogin: true
        }
    },
    {
        path: "/myStockRoomContract",
        name: "MyStockRoomContract",
        component: () =>
            import ("@/views/mine/myStockRoomContract.vue"),
        meta: {
            title: "我的二手房合同",
            isLogin: true
        }
    },
    {
        path: "/applyRecord",
        name: "ApplyRecord",
        component: () =>
            import ("@/views/mine/applyRecord.vue"),
        meta: {
            title: "申请记录",
            isLogin: true
        }
    },
    {
        path: "/contractPic",
        name: "ContractPic",
        component: () =>
            import ("@/views/mine/contractPic.vue"),
        meta: {
            title: "查看合同",
            isLogin: true
        }
    },
    {
        path: "/xieYiContractPic",
        name: "xieYiContractPic",
        component: () =>
            import ("@/views/mine/xieYiContractPic.vue"),
        meta: {
            title: "协议详情",
            isLogin: true
        }
    },
    {
        path: "/myArgument",
        name: "MyArgument",
        component: () =>
            import ("@/views/mine/myArgument.vue"),
        meta: {
            title: "我的评论",
            isLogin: true
        }
    },
    {
        path: "/constractComplete",
        name: "ConstractComplete",
        component: () =>
            import ("@/views/mine/constractComplete.vue"),
        meta: {
            title: "合同剩余信息完善",
            isLogin: true
        }
    },
    {
        path: "/showContract",
        name: "showContract",
        component: () =>
            import ("@/views/mine/showContract.vue"),
        meta: {
            title: "查看合同",
            isLogin: true
        }
    },
    {
        path: "/stockContractPic",
        name: "stockContractPic",
        component: () =>
            import ("@/views/mine/stockContractPic.vue"),
        meta: {
            title: "二手房查看合同",
            isLogin: true
        }
    },
    {
        path: "/showClfContract",
        name: "showClfContract",
        component: () =>
            import ("@/views/mine/showClfContract.vue"),
        meta: {
            title: "合同查看",
            isLogin: true
        }
    }, {
        path: "/sellerInfo",
        name: "SellerInfo",
        component: () =>
            import ("@/views/mine/sellerInfo.vue"),
        meta: {
            title: "卖方资金监管信息录入",
            isLogin: true
        }
    },
    {
        path: "/testRealName",
        name: "TestRealName",
        component: () =>
            import ("@/views/mine/testRealName.vue"),
        meta: {
            title: "进行实名认证及上传出买卖方相关资料",
            isLogin: true
        }
    },
    {
        path: "/testIdCard",
        name: "TestIdCard",
        component: () =>
            import ("@/views/mine/testIdCard.vue"),
        meta: {
            title: "身份认证",
        }
    }, {
        path: "/lookInfo",
        name: "LookInfo",
        component: () =>
            import ("@/views/mine/lookInfo.vue"),
        meta: {
            title: "查看资料",
            isLogin: true
        }
    }, {
        path: "/keepOnRecordApply",
        name: "KeepOnRecordApply",
        component: () =>
            import ("@/views/mine/keepOnRecord.vue"),
        meta: {
            title: "备案及监管申请",
            isLogin: true
        }
    }, {
        path: "/myArgumentList",
        name: "MyArgumentList",
        component: () =>
            import ("@/views/mine/myArgumentList.vue"),
        meta: {
            title: "我的评论",
            isLogin: true
        },
    }, {
        path: "/argumentMyHouse",
        name: "ArgumentMyHouse",
        component: () =>
            import ("@/views/mine/argumentMyHouse.vue"),
        meta: {
            title: "商品房购房评价",
            isLogin: true
        },
    }, {
        path: "/myClfArgumentList",
        name: "MyClfArgumentList",
        component: () =>
            import ("@/views/mine/myClfArgumentList.vue"),
        meta: {
            title: "二手房交易评价",
            isLogin: true
        },
    }, {
        path: "/argumentClf",
        name: "ArgumentClf",
        component: () =>
            import ("@/views/mine/argumentClf.vue"),
        meta: {
            title: "二手房交易评价",
            isLogin: true
        },
    }, {
        path: "/IWillBuy",
        name: "IWillBuy",
        component: () =>
            import ("@/views/mine/IWillBuy.vue"),
        meta: {
            title: "我要求购",
            isLogin: true
        },
    }, {
        path: "/WillBuyLit",
        name: "WillBuyLit",
        component: () =>
            import ("@/views/mine/WillBuyLit.vue"),
        meta: {
            title: "求购列表",
            isLogin: true
        },
    }, {
        path: "/WillBuyDetail",
        name: "WillBuyDetail",
        component: () =>
            import ("@/views/mine/WillBuyDetail.vue"),
        meta: {
            title: "我要求购详情",
            isLogin: true
        },
    }, {
        path: "/complainAndSuggest",
        name: "complainAndSuggest",
        component: () =>
            import ("@/views/mine/complainAndSuggest.vue"),
        meta: {
            title: "投诉建议",
            isLogin: true
        },
    }, {
        path: "/complainList",
        name: "complainList",
        component: () =>
            import ("@/views/mine/complainList.vue"),
        meta: {
            title: "投诉列表",
            isLogin: true
        },
    }, {
        path: "/buyList",
        name: "BuyList",
        component: () =>
            import ("@/views/mine/buyList.vue"),
        meta: {
            title: "求购列表",
        },
    }, {
        path: "/buyDetail",
        name: "BuyDetail",
        component: () =>
            import ("@/views/mine/buyDetail.vue"),
        meta: {
            title: "求购列表",
            isLogin: false
        },
    }, {
        path: "/forgetPhone",
        name: "ForgetPhone",
        component: () =>
            import ("@/views/mine/forgetPhone.vue"),
        meta: {
            title: "忘记手机号",
        },
    }, {
        path: "/chat",
        name: "Chat",
        component: () =>
            import ("@/views/mine/chat.vue"),
        meta: {
            title: "在线聊天",
            isLogin: true
        },
    },
    {
        path: "/chatWx",
        name: "chatWx",
        component: () =>
            import ("@/views/mine/chatWx.vue"),
        meta: {
            title: "在线聊天"
        },
    },
    {
        path: "/uploadSign",
        name: "uploadSign",
        component: () =>
            import ("@/views/mine/uploadSign.vue"),
        meta: {
            title: "上传签字页",
            isLogin: true
        },
    },
    // {
    //     path: "/qrCode",
    //     name: "qrCode",
    //     component: () =>
    //         import ("@/views/mine/qrCode.vue"),
    //     meta: {
    //         title: "扫描二维码"
    //     },
    // },

];
export default mineList;